import React from 'react'
import { Dropdown, DropdownOption } from '@carsys/ui'
import { alpha } from '@mui/material/styles'
import { Theme, outlinedInputClasses, svgIconClasses } from '@mui/material'

const style = {
  appBarElement: {
    marginLeft: 2,
    marginRight: 2,
    backgroundColor: 'primary.light',
    color: 'primary.contrastText',
    [`& .${outlinedInputClasses.disabled}`]: {
      color: 'rgba(0, 0, 0, 0.38) !important',
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.38) !important'
      }
    },
    [`& .${outlinedInputClasses.root}`]: {
      '& fieldset': { borderColor: (theme: Theme) => alpha(theme.palette.primary.contrastText, 0.4) }
    },
    [`& .${svgIconClasses.root}`]: {
      color: (theme: Theme) => alpha(theme.palette.primary.contrastText, 0.4)
    },
    [`& :hover, & .${outlinedInputClasses.focused}`]: {
      [`&.${outlinedInputClasses.root}`]: {
        '& fieldset': { borderColor: 'primary.contrastText' }
      },
      [`& .${svgIconClasses.root}`]: {
        color: 'primary.contrastText'
      }
    }
  },
  appBarLabel: {
    color: (theme: Theme) => alpha(theme.palette.primary.contrastText, 0.7),
    [`&.${outlinedInputClasses.focused}`]: {
      color: 'primary.contrastText'
    }
  },
  appBarInput: {
    color: 'primary.contrastText',
    '&:focus': {
      color: 'primary.contrastText',
      '& fieldset': { borderColor: 'primary.contrastText' }
    },
    '&:hover': {
      color: 'primary.contrastText'
    }
  }
}

type InheritedDropdownProps = Omit<
  React.ComponentProps<typeof Dropdown>,
  'color' | 'SelectProps' | 'className' | 'InputLabelProps' | 'inputProps' | 'fullWidth'
>

interface IDropDownProps extends InheritedDropdownProps {
  options?: IDropDownOption[]
}

interface IDropDownOption {
  text: string
  value: string
}

const AppBarDropDown: React.FC<IDropDownProps> = ({ options, sx, ...rest }: IDropDownProps) => {
  return (
    <Dropdown
      color='secondary'
      SelectProps={{ sx: style.appBarInput }}
      sx={{ ...style.appBarElement, ...sx }}
      InputLabelProps={{ sx: style.appBarLabel }}
      inputProps={{ sx: style.appBarInput }}
      fullWidth={false}
      {...rest}
    >
      {options?.map(item => (
        <DropdownOption value={item.value} key={item.value}>
          {item.text}
        </DropdownOption>
      )) || <DropdownOption value='loading' />}
    </Dropdown>
  )
}

export default AppBarDropDown
